import { render, staticRenderFns } from "./PointEditor.vue?vue&type=template&id=9d261532&"
import script from "./PointEditor.vue?vue&type=script&lang=js&"
export * from "./PointEditor.vue?vue&type=script&lang=js&"
import style0 from "./PointEditor.vue?vue&type=style&index=0&id=9d261532&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports